'use client';

import {useEffect} from 'react';
import copy from 'clipboard-copy';
import {m as motion} from 'motion/react';
import {usePathname} from 'next/navigation';
import {MenuItem} from 'react-aria-components';
import {checkLine, fileCopyLine} from 'src/utils/icons';
import RemixIcon from './RemixIcon';

type Props = {
  path?: string;
};

const ShareSheet = ({path}: Props) => {
  const pathname = usePathname();

  useEffect(() => {
    copy(`${process.env.NEXT_PUBLIC_BASE_URL}${path || pathname}`);
  }, []);

  return (
    <MenuItem>
      <div className="flex flex-col items-center w-[230px] py-4 px-2">
        <div className="relative mb-4 h-11">
          <motion.div
            className="flex justify-center items-center absolute -left-[22px] w-[44px] h-[44px] rounded-xl bg-[rgba(255,255,255,0.1)]"
            initial={{x: 0, rotate: '0deg', opacity: 0}}
            animate={{x: -30, rotate: '-6deg', opacity: 1}}
            transition={{duration: 1, ease: [0.22, 1, 0.36, 1]}}
          >
            <RemixIcon icon={fileCopyLine} color="white" />
          </motion.div>

          <motion.div
            className="flex justify-center items-center absolute -left-[22px] w-[44px] h-[44px] rounded-xl bg-white"
            initial={{x: 0, rotate: '0deg', opacity: 0}}
            animate={{x: 30, rotate: '6deg', opacity: 1}}
            transition={{duration: 1, ease: [0.22, 1, 0.36, 1]}}
          >
            <RemixIcon icon={checkLine} color="var(--purple)" />
          </motion.div>
        </div>

        <span className="text-xl font-semibold text-center block mb-1 text-white">Link copied!</span>

        <p className="text-center text-[rgba(255,255,255,0.8)] text-sm max-w-[200px]">
          Paste it anywhere to share with your friends and the world.
        </p>
      </div>
    </MenuItem>
  );
};

export default ShareSheet;
